import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useRef } from "react";
import { stringAvatar } from "../../../utils/CommonFunction";

interface TranscriptItem {
  speaker: string;
  text: string;
  starttime: number;
  endtime: number;
}

interface TranscriptDrawerProps {
  open: boolean;
  onClose: () => void;
  transcript: TranscriptItem[];
  onSeek?: (seconds: number) => void;
}

const formatTime = (seconds: number) => {
  const min = Math.floor(seconds / 60);
  const sec = Math.floor(seconds % 60);
  return `${min}:${sec.toString().padStart(2, "0")}`;
};

const TranscriptDrawer: React.FC<TranscriptDrawerProps> = ({
  open,
  onClose,
  transcript,
  onSeek,
}) => {
  const listRef = useRef<HTMLUListElement>(null);
  const scrollPos = useRef(0);

  const handleScroll = useCallback((e: React.UIEvent<HTMLUListElement>) => {
    console.log("Scroll event triggered", e.currentTarget.scrollTop);
    scrollPos.current = e.currentTarget.scrollTop;
  }, []);
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (listRef.current) {
          listRef.current.scrollTop = scrollPos.current;
        }
      }, 0);
    }
  }, [open]);
  return (
    <Drawer
      anchor="right"
      open={open}
      aria-hidden={!open}
      onClose={onClose}
      PaperProps={{ sx: { width: 400 } }}
    >
      <Box sx={{ display: "flex", alignItems: "center", p: 2, pb: 0 }}>
        <Typography
          fontSize={"24px"}
          color={"#0F1829"}
          fontWeight={600}
          flexGrow={1}
        >
          Transcript
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <List
        ref={listRef}
        sx={{ p: 2, height: "calc(100vh - 64px)", overflowY: "auto" }}
        onScroll={handleScroll}
      >
        {transcript.map((item, idx) => (
          <ListItem alignItems="flex-start" key={idx} sx={{ mb: 1, px: 0 }}>
            <ListItemText
              primary={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar {...stringAvatar(item.speaker, 34)} />
                  <Typography
                    color={"#0F1829"}
                    fontWeight={700}
                    fontSize={"14px"}
                  >
                    {item.speaker}
                  </Typography>
                  <Typography color={"#858585"} fontSize={"14px"}>
                    |
                  </Typography>
                  <Typography
                    variant="caption"
                    color="primary"
                    sx={{
                      cursor: onSeek ? "pointer" : "default",
                    }}
                    onClick={() => onSeek && onSeek(item.starttime)}
                  >
                    {formatTime(item.starttime)}
                  </Typography>
                </Box>
              }
              secondary={
                <Typography
                  color={"#0F1829"}
                  fontSize={"14px"}
                  lineHeight={"22px"}
                  pl={"42px"}
                >
                  {item.text}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default TranscriptDrawer;
